module.exports = __webpack_public_path__ + "img/t1-18.124cd73f.png";